export function abc()
{
	return dispatch=>dispatch({type:"text"})
}
export function addnew(x)
{
	return dispatch=>dispatch({type:"insert",payload:x})
}
export function del(id)
{
	return dispatch=>dispatch({type:"delete",payload:id})
}
export function del1(s)
{
	if(s===true) {return dispatch=>dispatch({type:"delete1",})}
	if(s==="all") {return dispatch=>dispatch({type:"delete3"})}
	if(s===false) {return dispatch=>dispatch({type:"delete2"})}
}

export function status(id)
{
	return dispatch=>dispatch({type:"option",payload:id})
}

export function edit(id)
{
	return dispatch=>dispatch({type:"update",payload:id})
}
